document.addEventListener("DOMContentLoaded", function () {
  const productItems = document.querySelectorAll('.m-product-item');

  productItems.forEach(function (item) {
    const daysInput = item.querySelector('.countdown_days');
    const countdownBox = item.querySelector('.countdown-box');
    if (!daysInput || !countdownBox) return;

    const days = parseInt(daysInput.value || "0");
    const productId = daysInput.dataset.productId;
    const endDateKey = `countdownEndDate_${productId}`;
    const daysKey = `countdownDays_${productId}`;

    let endDate = localStorage.getItem(endDateKey);
    const storedDays = localStorage.getItem(daysKey);

    // If no countdown or metafield has changed, reset countdown
    if (!endDate || parseInt(storedDays) !== days) {
      const newEndDate = new Date();
      newEndDate.setDate(newEndDate.getDate() + days);
      endDate = newEndDate.getTime();

      localStorage.setItem(endDateKey, endDate);
      localStorage.setItem(daysKey, days);
    } else {
      endDate = parseInt(endDate);
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance <= 0) {
        countdownBox.textContent = "Offer Ended";
        localStorage.removeItem(endDateKey);
        localStorage.removeItem(daysKey);
        return;
      }

      const d = Math.floor(distance / (1000 * 60 * 60 * 24));
      const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((distance % (1000 * 60)) / 1000);

      countdownBox.textContent =
        `${String(d).padStart(2, '0')}d : ${String(h).padStart(2, '0')}h : ${String(m).padStart(2, '0')}m : ${String(s).padStart(2, '0')}s`;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
